import {req} from './requestHelper';
import jwt from 'jsonwebtoken';
import {TOKEN_KEY, MENU_KEY} from '../constants';

const defaultAuthInfo = {userId: '', email : '', name : '訪客', roleId: '5', homePageId:'9701'};

export async function login(cred) {
    try {
        const res = await req('/api/login', {
            method: 'post',
            data: {...cred}
        });
        const {success, token, menus = []} = res.data;
        setAuth(success ? token : undefined);
        setMenus(success ? menus : []);
    } catch (e) {
        setAuth(undefined);
        setMenus([]);
    }

    return {auth: getAuth(), menus: getMenus()};
}

export async function loginV2(cred) {
    try {
        const res = await req('/api/login', {
            method: 'post',
            data: {...cred}
        });
        const {success, token, menus = []} = res.data;
        setAuth(success ? token : undefined);
        if (success) {
            setMenus(menus);
        }
    } catch (e) {
        setAuth(undefined);
        setMenus([]);
    }

    return {auth: getAuth(), menus: getMenus()};
}

export function logout() {
    clearAuth();
}

export async function anonInit() {
    clearAuth();
    try {
        const res = await req('api/auth/getAnonInit');
        const {success, token, menus = []} = res.data;
        setAuth(success ? token : undefined);
        setMenus(success ? menus : []);
    } catch (e) {
        setAuth(undefined);
        setMenus([]);
    }

    return {auth: getAuth(), menus: getMenus()};
}

export const getAuth = () => {
    const token = getAuthToken();
    if (token) {
        const {userId = '', email = '', name= '訪客', roleId = '5', homePageId='9701'} = jwt.decode(token);
        //過期
        if (isTokenExpired(token)) {
            clearAuth();
            return {...defaultAuthInfo};
        }
        return {userId, email, name, roleId, homePageId };
    }
    return {...defaultAuthInfo};
};

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);
export const getMenus = () => JSON.parse(localStorage.getItem(MENU_KEY) || '[]');

export const clearAuth = () => {
    if(getAuthToken()){
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(MENU_KEY);
    }
};

export const setAuth = token => {
    localStorage.removeItem(TOKEN_KEY);
    if (token) {
        localStorage.setItem(TOKEN_KEY, token);
    }
};

const setMenus = (menus = []) => {
    localStorage.removeItem(MENU_KEY);
    if(menus){
        localStorage.setItem(MENU_KEY, JSON.stringify(menus));
    }
};

const isTokenExpired = token => {
    const {exp} = jwt.decode(token);
    const currentTime = Date.now().valueOf() / 1000;
    return !exp || exp < currentTime;
};

export async function getMenusByRoleId(roleId) {
    return (await req(`api/auth/getMenus/${roleId}`,)).data;
}

